"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWildcardValue = void 0;
var splitPath_1 = __importDefault(require("./splitPath"));
var getValue_1 = __importDefault(require("./getValue"));
var getWildcardValue = function (obj, path, patch) {
    var parts = (0, splitPath_1.default)(path);
    var wildcardIdx = parts.indexOf("*");
    patch.forEach(function (x) {
        var partsPatch = (0, splitPath_1.default)(x.path);
        if (wildcardIdx < partsPatch.length) {
            path = path.replace("*", partsPatch[wildcardIdx]);
        }
        else {
            // search in the value and see what changed
        }
    });
    if (!path.includes("*")) {
        return (0, getValue_1.default)(obj, path);
    }
};
exports.getWildcardValue = getWildcardValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0V2lsZGNhcmRWYWx1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mbi9nZXRXaWxkY2FyZFZhbHVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDBEQUFvQztBQUNwQyx3REFBa0M7QUFFM0IsSUFBTSxnQkFBZ0IsR0FBRyxVQUFDLEdBQUcsRUFBRSxJQUFJLEVBQUUsS0FBSztJQUMvQyxJQUFJLEtBQUssR0FBRyxJQUFBLG1CQUFTLEVBQUMsSUFBSSxDQUFDLENBQUM7SUFDNUIsSUFBSSxXQUFXLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUVyQyxLQUFLLENBQUMsT0FBTyxDQUFDLFVBQUMsQ0FBQztRQUNkLElBQUksVUFBVSxHQUFHLElBQUEsbUJBQVMsRUFBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUM7UUFFbkMsSUFBSSxXQUFXLEdBQUcsVUFBVSxDQUFDLE1BQU0sRUFBRTtZQUNuQyxJQUFJLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsVUFBVSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUM7U0FDbkQ7YUFBTTtZQUNMLDJDQUEyQztTQUM1QztJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDdkIsT0FBTyxJQUFBLGtCQUFRLEVBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQzVCO0FBQ0gsQ0FBQyxDQUFDO0FBakJXLFFBQUEsZ0JBQWdCLG9CQWlCM0IifQ==